import { schema } from 'normalizr';

import { quoteItems } from '../quotes/schema';

export const order = new schema.Entity('orders', {
  quoteItems: quoteItems,
});
export const orders = [order];
